import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import Moment from 'moment'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    loggedin: !!localStorage.getItem('eydsuser'),
    user: localStorage.getItem('eydsuser') != null ? JSON.parse(localStorage.getItem('eydsuser')) : {},
    deneme: {},
    sinav: {},
    sorular: [],
    cevaplar: [],
    favoriSorular: [],
    hata: '',
    kdadika: 1,
    baslangicZamani: new Date(),
    bitisZamani: Moment(new Date()).add(30, 'm').format('YYYY-MM-DD HH:mm:ss'),
    sonSoruNo: 1
  },
  getters: {
    aktifSoru: (state) => {
      let s = state.sorular.length > 0 ? state.sorular.filter(soru => soru.SoruNo === state.sonSoruNo.toString())[0] : null
      if (s) {
        const c = state.cevaplar.length > 0 ? state.cevaplar.filter((cevap) => {
          return cevap.soruId === s._id
        })[0] : null
        if (c) {
          s.cevap = c.cevap
        } else {
          s.cevap = null
        }

        const f = state.favoriSorular.length > 0 ? state.favoriSorular.filter((fsoru) => {
          return fsoru.soruId === s._id
        }) : []
        if (f.length > 0) {
          s.yenidenBakilacak = true
        } else {
          s.yenidenBakilacak = false
        }
        s.Soru = s.Soru.replace(/\n/g, '<br />')
        for (var i; i < s.Cevaplar.length; i++) {
          s.Cevaplar[i] = s.Cevaplar[i].replace(/\n/g, '<br />')
        }
      } else {
        s = {}
      }
      return s
    }
    // ,
    // kalanSoru: (state) => {
    //   return state.sorular.length > 0 ? state.sorular.filter(soru => !soru.cevap).length : 0
    // }
  },
  mutations: {
    LOGIN: (state, link) => {
      state.loggedin = true
      state.user = link
    },
    LOGOUT: (state) => {
      state.loggedin = false
      state.user = {}
    },
    SET_DENEME: (state, deneme) => {
      state.deneme = deneme
      state.baslangicZamani = Moment(deneme.baslamaTarihi).format('YYYY-MM-DD HH:mm:ss')
    },
    SET_SINAV: (state, sinav) => {
      state.sinav = sinav
    },
    SET_SORULAR: (state, sorular) => {
      state.sorular = sorular
    },
    SET_CEVAPLAR: (state, cevaplar) => {
      state.cevaplar = cevaplar
      state.cevaplar.forEach(function (cevap) {
        const soruid = cevap.soruId
        const indx = _.findIndex(state.sorular, function (s) {
          return s._id === soruid
        })
        state.sorular[indx].cevap = cevap
      })
    },
    SET_FAVORISORULAR: (state, fsorular) => {
      state.favoriSorular = fsorular
      state.favoriSorular.forEach(function (fsoru) {
        const soruid = fsoru.soruId
        const indx = _.findIndex(state.sorular, function (s) {
          return s._id === soruid
        })
        state.sorular[indx].yenidenBakilacak = true
      })
    },
    ADD_CEVAP: (state, cevap) => {
      const indx = _.findIndex(state.cevaplar, function (c) {
        return c._id === cevap._id
      })
      if (indx > -1) {
        state.cevaplar[indx] = cevap
      } else {
        state.cevaplar.push(cevap)
      }
      const indxsoru = _.findIndex(state.sorular, function (s) {
        return s._id === cevap.soruId
      })
      state.sorular[indxsoru].cevap = cevap
    },
    ADD_FAVORI: (state, fsoru) => {
      const indx = _.findIndex(state.favoriSorular, function (f) {
        return f._id === fsoru._id
      })
      if (indx > -1) {
        state.favoriSorular[indx] = fsoru
      } else {
        state.favoriSorular.push({soruId: fsoru._id})
      }
      const indxfsoru = _.findIndex(state.sorular, function (s) {
        return s._id === fsoru._id
      })
      state.sorular[indxfsoru].yenidenBakilacak = true
    },
    REMOVE_FAVORI: (state, fsoru) => {
      state.favoriSorular = state.favoriSorular.filter(function (soru) {
        return soru._id !== fsoru._id
      })
      const indxfsoru = _.findIndex(state.sorular, function (s) {
        return s._id === fsoru._id
      })
      state.sorular[indxfsoru].yenidenBakilacak = false
    },
    SET_ERROR: (state, hata) => {
      state.hata = hata
    },
    SET_SORUNO: (state, soruno) => {
      state.sonSoruNo = soruno
    }
  },
  actions: {
    async Login_ACTION ({commit}, user) {
      try {
        console.log(user, 'user')
        const data = user.data
        console.log(data, 'data')
        const u = JSON.stringify({email: data.email, name: data.firstName, surname: data.lastName, token: user.token})
        await localStorage.setItem('eydsuser', u)
        commit('LOGIN', JSON.parse(u))
        console.log(u)
        if (user.router) {
          user.router.push('UserMain')
        }
      } catch (e) {
        console.log(e)
      }
    },
    async logout_ACTION ({commit}, next) {
      await localStorage.removeItem('eydsuser')
      console.log('Kullanıcı Çıkış Yapıyor')
      commit('LOGOUT')
      if (next) {
        next()
      }
    },
    startQuiz_ACTION  ({commit}, sinavBilgileri) {
      // sinavBilgileri.deneme.kalandakika = sinavBilgileri.kalandakika
      commit('SET_DENEME', sinavBilgileri.deneme)
      commit('SET_SINAV', sinavBilgileri.sinav)
      commit('SET_SORULAR', sinavBilgileri.sorular)
      commit('SET_CEVAPLAR', sinavBilgileri.cevaplar)
      commit('SET_FAVORISORULAR', sinavBilgileri.deneme.geriDonulecekSoruNolar || [])
      commit('SET_SORUNO', 1)
    },
    setError_ACTION  ({commit}, hata) {
      commit('SET_ERROR', hata)
    },
    setLastQuestion_ACTION  ({commit}, soruno) {
      commit('SET_SORUNO', soruno)
    },
    setSonrakiSoru_ACTION ({commit, state}) {
      console.log('Sonraki Soru')
      const maxSoruno = _.maxBy(state.sorular, function (soru) { return Number(soru.SoruNo) })
      if (state.sonSoruNo + 1 > maxSoruno.SoruNo) {
        commit('SET_SORUNO', 1)
      } else {
        commit('SET_SORUNO', state.sonSoruNo + 1)
      }
    },
    setOncekiSoru_ACTION ({commit, state}) {
      const maxSoruno = _.maxBy(state.sorular, function (soru) { return Number(soru.SoruNo) })
      if (state.sonSoruNo - 1 < 1) {
        console.log('Sona Dönüyor')
        commit('SET_SORUNO', maxSoruno.SoruNo)
      } else {
        commit('SET_SORUNO', state.sonSoruNo - 1)
      }
    },
    setSoru_ACTION ({commit}, soruno) {
      commit('SET_SORUNO', soruno)
    },
    addCevap_ACTION ({commit}, cevap) {
      commit('ADD_CEVAP', cevap)
    },
    addRemoveFAVORI_ACTION ({commit}, soru) {
      if (soru.eklesil === true) {
        commit('ADD_FAVORI', soru.soru)
      } else {
        commit('REMOVE_FAVORI', soru.soru)
      }
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store.js